import React, { useRef } from 'react';

const FileUpload = ({
  accept = '*',
  onChange,
  preview = null,
  defaultPreview = null,
  label = 'Upload File',
  className = '',
  previewClassName = '',
  error = '',
  ...props
}) => {
  const fileInputRef = useRef(null);

  // Handle file change
  const handleChange = (e) => {
    const file = e.target.files[0];
    if (file && onChange) {
      onChange(file);
    } else if (onChange) {
      onChange(null);
    }
  };

  // Handle click to open file dialog
  const handleClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <div className="flex flex-col items-center">
      {/* File upload container */}
      <div className={`relative group ${className}`}>
        {/* Hidden file input */}
        <input
          type="file"
          ref={fileInputRef}
          accept={accept}
          onChange={handleChange}
          className="hidden"
          aria-label={label}
          {...props}
        />

        {/* Clickable upload area */}
        <div
          onClick={handleClick}
          className="cursor-pointer relative w-full h-full"
        >
          {preview || defaultPreview ? (
            // Image preview
            <div className="w-full h-full relative overflow-hidden rounded-full">
              <img
                src={preview || defaultPreview}
                alt=""
                className={`w-full h-full object-cover object-center ${previewClassName}`}
                onError={(e) => {
                  console.error('Image failed to load:', e.target.src);
                }}
              />
              
              {/* Camera overlay for existing image */}
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-40 transition-all duration-200 flex items-center justify-center">
                <div className="w-10 h-10 bg-white bg-opacity-90 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200 shadow-lg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 text-gray-700"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                </div>
              </div>
            </div>
          ) : (
            // Empty state
            <div className="w-full h-full bg-gray-100 flex flex-col items-center justify-center border-2 border-dashed border-gray-300 hover:border-orange-400 transition-colors rounded-full">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-8 w-8 text-gray-400 mb-1"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
              <span className="text-xs text-gray-500 text-center px-2">Add Photo</span>
            </div>
          )}
        </div>
      </div>

      {/* Label below the upload area */}
      <p className="mt-2 text-sm text-gray-600 text-center">{label}</p>

      {/* Error message */}
      {error && (
        <p className="mt-1 text-sm text-red-600 text-center">{error}</p>
      )}
    </div>
  );
};

export default FileUpload;